import Text from '@/app/components/common/Text'
import React from 'react'

interface HighlightedTextProps {
	text: string
	highlight: string
}

const HighlightedText: React.FC<HighlightedTextProps> = ({
	text,
	highlight,
}) => {
	const keywords = highlight
		.toLowerCase()
		.split(/\s+/)
		.filter((k) => k.length > 1)

	const escapeRegExp = (string: string) => {
		return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
	}

	const parts = text.split(
		new RegExp(`(${keywords.map(escapeRegExp).join('|')})`, 'gi')
	)

	return (
		<>
			<Text size="base" font="semibold" className="leading-none">
				{parts.map((part, i) => {
					if (part === undefined) return null
					return keywords.some(
						(keyword) => part.toLowerCase() === keyword.toLowerCase()
					) ? (
						<span className="highlight" key={i}>
							{part}
						</span>
					) : (
						<React.Fragment key={i}>{part}</React.Fragment>
					)
				})}
			</Text>
		</>
	)
}

export default HighlightedText
